<template>
	<div style="width: 100%;background: #fff;height: 600px;" class="d-flex m-2">
		<div style="width: 48%;margin-right: 2%;" class="m-1">
			<div>
				<el-button type="primary" size="mini" icon="el-icon-search">查询</el-button>
				<el-button type="success" size="mini" icon="el-icon-bottom">导出</el-button>
			</div>
			<div>
				<el-table class="mt-3" :data="tableData" style="width: 100%" size="mini" :max-height="maxHeight">
					<el-table-column align="center" prop="id" width="60" label="编号"></el-table-column>
					<el-table-column prop="cplx" label="类型"></el-table-column>
					<el-table-column align="center" prop="sl" label="数量" fixed="right" width="100"></el-table-column>
				</el-table>
			</div>
		</div>
		<div style="width: 50%;" class="m-1" :max-height="maxHeight">
			<div style="font-weight: 800;">库存统计</div>
			<div ref="myCharta" style="width: 100%; height: 580px;"></div>
		</div>
	</div>
</template>

<script>
import * as vueEcharts from 'echarts';
let echarts = require('echarts');
export default {
	data() {
		return {
			myChart: null,
			tableData: [],
			tjname: [],
			tjnum: [],
			maxHeight: 0
		};
	},
	mounted() {
		// 画统计图
		this.$nextTick(() => {
			this.maxHeight = window.innerHeight - 290;
		});
		this.drawLine();
	},
	created() {
		this.axios.get('/admin/kcfltj', { token: true }).then(res => {
			let list = res.data.data;

			var cplx = [];
			var newdata = [];
			var num = 0;
			for (let i of list) {
				if (cplx.indexOf(i.cplx) == -1) {
					cplx.push(i.cplx);
				}
			}
			for (let i of cplx) {
				let data = list.filter(item => item.cplx == cplx[num]); // 过滤filter()
				let tjsl = data.map(i => {
					let kcsl = 0;
					return (kcsl += i.kcsl);
				});
				tjsl = tjsl.reduce((a, b) => a + b); // 求和reduce()
				let e = {
					id: num,
					cplx: cplx[num],
					sl: tjsl
				};
				newdata.push(e);
				num += 1;
			}
			this.tableData = newdata.sort((a, b) => { return b.sl - a.sl; }); // 排序sort()
			this.tjname = this.tableData.map(i => {
				return {
					value:i.sl,
					name:i.cplx
				};
			});
		});
	},
	methods: {
		drawLine() {
			// 初始化echarts实例
			let myCharta = echarts.init(this.$refs.myCharta);
			var that = this;
			setTimeout(function() {
				// 配置参数
				myCharta.setOption({
					tooltip: {
						trigger: 'item'
					},
					legend: {
						orient: 'vertical',
						left: 'left'
					},
					series: [
						{
							name: '库存统计',
							type: 'pie',
							radius: '50%',
							data: that.tjname,
							emphasis: {
					 		itemStyle: {
									shadowBlur: 10,
									shadowOffsetX: 0,
									shadowColor: 'rgba(0, 0, 0, 0.5)'
								}
							}
					 }
					]
				});
			}, 1000);
		}
	}
};
</script>

<style></style>
